﻿/*
 * Transform role name to short name.
 * @example 'Director Quality and Regulatory Affairs' => 'DQA'
 * @example 'Regulatory Affairs Manager' => 'RAM'
 * @example 'Project Manager' => 'PM'
 * @example 'Developer' => 'DE'
 * @example '!' => '!'
 * */
export function getRoleShortName(roleName: string) {
  const parts = roleName.split(' ');
  if (parts.length >= 3) {
    return `${parts[0][0].toUpperCase()}${parts[1][0].toUpperCase()}${parts[2][0].toUpperCase()}`;
  } else if (parts.length >= 2) {
    return `${parts[0][0].toUpperCase()}${parts[1][0].toUpperCase()}`;
  } else if (parts[0].length >= 2) {
    return `${parts[0][0].toUpperCase()}${parts[0][1].toUpperCase()}`;
  } else {
    return parts[0][0].toUpperCase();
  }
}
